<script setup lang="ts">
import DomainsPage from '../features/domains/DomainsPage.vue';
</script>

<template>
  <DomainsPage />
</template>
